/**
 *  分模块翻译，方便维护
 *  lang/en-us/module/portal/sku.js
 */

export default {
  "sku": {
    "pallets":"Type",
    "accurate":"Exact",
    "parameters":"Params",
    "inv_clas":"Inv. Class",

    "non_std_lstg":"For non-standard listings, please check the model/brand and batch/delivery date, and contact the product manager to update the product library",
    "eol": "EOL",
    "yes": "Yes",
    "no": "No",
    "data_sheet": "Data Sheet",
    "item": "Product#",
    "catalog": "Catalog#",
    "offers": "Discount",
    "founding": "Establish",
    "account": "Acct.",
    "refund": "Return",
    "sample": "SP",
    "special_price": "OTO",
    "moq": "MOQ",
    "mpq": "MPQ",
    "free_shipping": "FS",
    "subtotal": "Subtotal",
    "group_buy":"Grp. Buy",
    "buy_now":"Buy Now",
    "sell_now":"Sell Now",
    "add_to_cart": "Add to Cart",
    // 拼团
    "group_buy_s_p":"Grp. Buy S.P.",
    "time":"Time",
    "start_at":"Start At ",
    "end_at":"End At ",
    "ended":"Ended",
    "join_group":"Join Group",
    "progress":"Progress",
    "joined_group":"Joined Group",
    "rem_g_s_b":"RemGBS",
    "full":"F",
  }
};
